module.exports = __webpack_public_path__ + "img/winner-hours.105b86f1.png";